'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$() {
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_defaultMake$lzy6 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_defaultMakebitmap$6 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_make$lzy6 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_makebitmap$6 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_given_Ordering_Type$lzy6 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_given_Ordering_Typebitmap$6 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_CannotParseError$lzy1 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_CannotParseErrorbitmap$1 = false;
}
export { $c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ as $c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ };
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.constructor = $c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$;
/** @constructor */
function $h_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$() {
}
export { $h_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ as $h_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ };
$h_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype = $c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype;
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_defaultMakebitmap$6)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_defaultMake$lzy6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_defaultMakebitmap$6 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_defaultMake$lzy6;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_makebitmap$6)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_make$lzy6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_makebitmap$6 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_make$lzy6;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.given_Ordering_Type__s_math_Ordering = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_given_Ordering_Typebitmap$6)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_given_Ordering_Type$lzy6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_FrameworkDateTime$Newtype__given_Ordering_Type__s_math_Ordering(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_given_Ordering_Typebitmap$6 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_given_Ordering_Type$lzy6;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.CannotParseError__Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_CannotParseErrorbitmap$1)) {
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_CannotParseError$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_CannotParseErrorbitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$__f_CannotParseError$lzy1;
});
$c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$, "app.data.types_drug$package$DrugRequestCreatedAt$", ({
  Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_data_FrameworkDateTime$Newtype: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ as $d_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ };
var $n_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$;
function $m_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$() {
  if ((!$n_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$)) {
    $n_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ = new $c_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$();
  }
  return $n_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$;
}
export { $m_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ as $m_Lapp_data_types\uff3fdrug$package$DrugRequestCreatedAt$ };
//# sourceMappingURL=app.data.types_drug$package$-Drug-Request-Created-At$.js.map
